<template>
    <div>
        <span class="small-icons heart-icon active" @click="toggleWishlist" v-if="isAtLeastOneInWishlist"></span>
        <span class="small-icons heart-icon" @click="toggleWishlist" v-else></span>

        <div v-if="showOptions && coloredProduct.variants[0].size.code !== 'None'">
            <div class="wishlist-size-selector">
                <div class="wishlist-size-selector-header">
                    {{ __('frontend_js.category.wishlist.add') }}
                </div>
                <div class="wishlist-sizes">
                    <div>
                        <table class="table wishlist-size-table">
                            <tbody>
                                <tr
                                    v-for="variant in coloredProduct.variants"
                                    :key="variant.id"
                                    @click="selectSize(variant.size.id)"
                                >
                                    <td v-if="variant.size.special_code != null">
                                        {{ variant.size.special_code }}
                                    </td>
                                    <td v-else>
                                        <span v-if="variant.size.code === 'None'">
                                            {{ __('frontend_js.category.wishlist.size_none') }}
                                            <!-- {{ variant.size.code }} -->
                                        </span>
                                        <span v-else>
                                            {{ variant.size.code }}
                                        </span>
                                    </td>
                                    <td
                                        class="wishlist-selected"
                                        v-if="selectedSizes.filter(s => s == variant.size.id).length > 0"
                                    ></td>
                                    <td v-else></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="wishlist-size-buttons">
                    <div>
                        <button @click="submitWihslistChoices" class="shop-button text-uppercase">
                            {{ __('frontend_js.category.wishlist.confirm') }}
                        </button>
                    </div>
                    <div class="white-button">
                        <button @click="cancelChoices" class="shop-button text-uppercase anchor-button no-underline">
                            {{ __('frontend_js.category.wishlist.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import collect from 'collect.js';
import { mapGetters } from 'vuex';
export default {
    props: {
        coloredProduct: {},
        redirectToProduct: {
            type: Boolean,
            required: false,
            default: false,
        },
        linkToCp: '',
    },
    data() {
        return {
            showOptions: false,
            selectedSizes: [],
        };
    },
    computed: {
        ...mapGetters({
            wishlist: 'auth/wishlist',
            authCheck: 'auth/check',
        }),
        isAtLeastOneInWishlist() {
            return !!this.selectedSizes.length;
        },
    },
    methods: {
        toggleWishlist() {
            if (!this.authCheck) {
                if (this.redirectToProduct) {
                    window.location.href =
                        `/` + __('frontend_js.routes.login') + `?url=${this.linkToCp}&warning-message=wishlist-must-be-logged-in`;
                    return;
                } else {
                    // To be automatic links
                    window.location.href =
                        `/` +
                        __('frontend_js.routes.login') +
                        `?url=${window.location.href}&warning-message=wishlist-must-be-logged-in`;
                    return;
                }
            }
            this.$emit('wishlictClicked');
            this.showOptions = !this.showOptions;

            // auto select size None
            if (
                this.coloredProduct.variants.length === 1 &&
                this.coloredProduct.variants[0].size.code === 'None' &&
                this.showOptions === true
            ) {
                this.selectSize(this.coloredProduct.variants[0].size.id);
                this.submitWihslistChoices();
            }
        },
        cancelChoices() {
            this.initializeCreatedSizes();
            if (this.selectedSizes.filter(s => s.inWishlist).length == 0) {
            }
            this.toggleWishlist();
            this.$emit('closedWishlistPopup', this.coloredProduct.id);
        },
        selectSize(id) {
            let item = collect(this.selectedSizes).first(i => i == id);
            //Unticking of already selected choices
            if (item) {
                this.selectedSizes = this.selectedSizes.filter(i => i != id);
            } else {
                //Inserting new item to selected items in wishlist
                this.selectedSizes.push(id);
            }
        },
        submitWihslistChoices() {
            this.$http
                .post('user/wishlist', {
                    sizes: this.selectedSizes,
                    coloredProduct: this.coloredProduct.id,
                })
                .then(({ data }) => {
                    // alert('Wishlist for this item has been updated');
                    this.showOptions = false;
                    this.$store.commit('auth/FETCH_WISHLIST', { wishlist: data });
                    this.$emit('closedWishlistPopup', this.coloredProduct.id);
                });
        },
        initializeCreatedSizes() {
            if (this.wishlist != null) {
                this.selectedSizes = collect(this.wishlist.variants)
                    .whereIn('id', collect(this.coloredProduct.variants).pluck('id').items)
                    .pluck('size_id')
                    .all();
            }
        },
    },
    mounted() {
        this.initializeCreatedSizes();
    },
};
</script>

<style lang="scss" scoped></style>
